function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.50355 5.18581L9.8629 3.833H5.41413C5.09341 3.833 4.83336 3.57409 4.83336 3.24967C4.83336 2.92753 5.09284 2.66634 5.41413 2.66634H9.86447L8.50355 1.31189C8.27782 1.08731 8.27582 0.725214 8.50255 0.4997C8.72756 0.27568 9.09585 0.278885 9.31859 0.500697L11.6632 2.83396C11.7938 2.96384 11.8495 3.13972 11.8294 3.30856C11.8177 3.43873 11.762 3.56547 11.6632 3.66374L9.31859 5.997C9.093 6.22159 8.72913 6.22359 8.50255 5.998C8.27739 5.77398 8.28067 5.40755 8.50355 5.18581Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.49651 8.68581L2.13715 7.333H6.58592C6.90664 7.333 7.16669 7.07409 7.16669 6.74967C7.16669 6.42753 6.90721 6.16634 6.58592 6.16634H2.13559L3.49651 4.81189C3.72223 4.58731 3.72423 4.22521 3.4975 3.9997C3.27249 3.77568 2.9042 3.77888 2.68146 4.0007L0.336879 6.33396C0.206284 6.46384 0.1506 6.63972 0.170681 6.80856C0.182359 6.93872 0.238043 7.06547 0.336879 7.16374L2.68146 9.497C2.90705 9.72159 3.27092 9.72359 3.4975 9.498C3.72266 9.27398 3.71939 8.90755 3.49651 8.68581Z"
});

var SvgTransfer = function SvgTransfer(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "white"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/transfer.fd30de23.svg";
export { SvgTransfer as ReactComponent };